// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3-oHU","consentsList":"PatientConsents_consentsList__3e6EQ","consentsListEmpty":"PatientConsents_consentsListEmpty__3Opht"};